import React from 'react';
import { t } from 'i18next';
import Money from '../Common/Money/Money';
import InfoIcon from '../icons/InfoIcon';
import styles from './ticketCard.module.css';
import CloseIcon from '../icons/CloseIcon';

const ProductSeat = ({
  product,
  subTitle,
  handleRemove,
  onInfoClick,
  onlyOne = false,
  hasMoreInfo = false,
}) => {
  const renderPrice = () => {
    let price = product.prices.price;

    return <Money value={price} decimal={false} />;
  };

  const onRemove = () => {
    if (handleRemove) handleRemove(product.seatProps.id);
  };

  const renderSubtitle = () => {
    return (
      <>
        {t('upToGuests', { pax: product.pax })}
        {product.extraPax && product.extraPax > 0 ? (
          <span>
            {' '}
            + {product.extraPax} {t('extraGuests')} ($)
          </span>
        ) : null}
      </>
    );
  };

  return (
    <div className='mt-2'>
      <div className='row'>
        <div className={`col pr-0`}>
          <div className={styles.container}>
            <div className='row m-0' style={{ minHeight: '86px' }}>
              {product.images &&
              product.images.length > 0 &&
              product.specialType !== 'DRINK_HOUR' ? (
                <div className='col-auto my-auto pl-2 pr-0'>
                  <div className='position-relative'>
                    <img
                      src={product.images[0]}
                      title={product.name}
                      className={styles.productImage}
                      alt='product'
                    />

                    {product.locationCode && (
                      <div
                        className={styles.productCode}
                        style={{ backgroundColor: product.hexColor }}
                      >
                        {product.locationCode}
                      </div>
                    )}
                  </div>
                </div>
              ) : null}

              <div className={`col text-truncate my-auto px-2`}>
                <div className={`fw-semibold text-truncate ${styles.productName}`}>
                  {product.name}
                  {hasMoreInfo ? (
                    <span className={styles.productInfoIcon} onClick={onInfoClick}>
                      <InfoIcon size='13px' styles={{ marginTop: '-3px' }} />
                    </span>
                  ) : null}
                </div>

                <div
                  className={`${styles.productSubTitle} font-small text-truncate light line-height-1`}
                >
                  {subTitle}
                </div>
                <div className={styles.productPrice}>
                  <span className='fw-semibold'>{renderPrice()}</span>
                </div>
                {product.prices.consumption > 0 && (
                  <div
                    className={`${styles.productSubTitle} font-small text-truncate light line-height-1`}
                  >
                    {t('consumptionCreditIncluded', { consumption: product.prices.consumption })}
                  </div>
                )}
              </div>

              {product.quantity > 0 && !onlyOne && (
                <div className={`col-auto ${styles.quantity} pl-0 pr-2 my-auto`}>
                  {product.quantity}
                </div>
              )}
            </div>
            {hasMoreInfo && (
              <div className={styles.moreInfo} onClick={onInfoClick}>
                {t('moreInfo')}
              </div>
            )}
          </div>
        </div>
        <div className='col-auto pl-0'>
          <div className={styles.quantityContainer}>
            <button className={styles.add} onClick={() => onRemove()}>
              <CloseIcon size={24} color='#000' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSeat;
